const languageDict = {
    ja: {
        'Sign in to your account': 'ログイン',
        'Username': 'ユーザ名',
        'Enter your Username': 'ユーザ名',
        'Password': 'パスワード',
        'New Password': '新しいパスワード',
        'Enter your password': 'パスワード',
        'Forget your password? ': 'パスワードを忘れた場合',
        'Reset password': 'パスワードのリセット',
        'No account? ': ' ',
        'Create a new account': 'ユーザー登録',
        'Create account': 'ユーザー登録',
        'Sign in': 'ログイン',
        'Sign In': 'ログイン',
        'Reset your password': 'パスワードのリセット',
        'Back to Sign In': 'ログイン',
        'Send Code': '認証コードの発行',
        'Have an account? ': ' ',
        'Create Account': '登録',
        'Confirm Sign Up': 'ユーザー登録の確認',
        'Code': '認証コード',
        'Confirmation Code': '認証コード',
        'Lost your code?': '認証コードが届かない場合',
        'Resend Code': '再送信',
        'Confirm': '確認',
        'Submit': '登録',
        'Confirmation code cannot be empty': '認証コードを入力してください',
        'chirashi-vision.com': 'チラシビューアー',
        'Management': '管理',
        'Page': 'ページ',
        'TO_BE_CREATED': '作成待機中',
        'CREATED': '作成済',
        'TO_BE_UPDATED': '変更待機中',
        'UPDATED': '変更済',
        'TO_BE_DELETED': '削除待機中',
        'DELETED': '削除済',
        'Username cannot be empty': 'ユーザー名を入力してください',
        'Custom auth lambda trigger is not configured for the user pool.': 'パスワードを入力してください',
        'Password cannot be empty': 'パスワードを入力してください',
        'User does not exist.': 'ユーザー名またはパスワードが間違っています',
        'Incorrect username or password.': 'ユーザー名またはパスワードが間違っています'
    }
}

export default languageDict
